import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { getNotificationProviderOptionFromPossibleProviders } from "../constants/providers.constant";
import { NotificationConfigurationsAvailableNotificationData, NotificationConfigurationsData } from "../types/configurations.type";

export const updateNotificationsConfigurationsDefaultValues = (
  availableNotifications: NotificationConfigurationsAvailableNotificationData[],
  configurations?: Record<string, NotificationConfigurationsData>
) => {
  return {
    ...availableNotifications.reduce((prev, { notification_klass, possible_providers }) => {
      const config = configurations?.[notification_klass];
      const providers = getNotificationProviderOptionFromPossibleProviders(possible_providers);

      return {
        ...prev,
        [notification_klass]: Number(config?.provider_klasses?.length || 0) === 0
          ? { value: 'all', label: 'Todos' }
          : config?.provider_klasses
            ? strategyToOptions({ [config.provider_klasses[0]]: providers[config.provider_klasses[0] as never] })[0]
            : null,
      }
    }, {})
  }
}
